import AppConfig from '@/app.config.js'
import { adminMenuItems, memberMenuItems } from "@/configs/menu.config.js"

class LayoutService {

    menuItems() {
        let Role = localStorage.getItem(AppConfig.auth.userRole)
        if(Role === 'Admin'){
            return adminMenuItems
        }else
        if(Role === 'Member'){
            return memberMenuItems
        }
    }

}

export default new LayoutService();
